import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../Context';

import s from './StageContainer.scss';

export interface Props {
  /** optionally skip the inner div */
  withoutInnerWrapper?: boolean;
  className?: string;
}

const StageContainer = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<Props>
>(({ withoutInnerWrapper, className, children }, ref) => {
  const { isTheater, isFullscreen } = useDeviationViewContext();

  return (
    <div
      className={classnames(
        s['root'],
        isTheater && s['theater'],
        isFullscreen && s['fullscreen'],
        className
      )}
      ref={ref}
    >
      {withoutInnerWrapper && children}
      {!withoutInnerWrapper && (
        <div className={s['stage-content']}>{children}</div>
      )}
    </div>
  );
});
StageContainer.displayName = 'StageContainer';

export default StageContainer;
